import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import styled from "styled-components"

import { LIST } from "const"
import { RrsTemplateLevel } from "server/models"
import { hasAccess } from "client/utils"
import {
    PRM_RRS_CATEGORY,
    StoreType,
    RrsTemplateLevelList,

    SetRrsTemplateRiskMapGenerated,
    DeleteRrsTemplateLevel,

    setRrsTemplateLevelListByCategory,
    setRrsTemplateEdit,
    addModal,
} from "client/store"
import {
    Button,
    Table,
    DeleteRow,
} from "client/components"

import Columns from "./columns"
import TemplateLevelEdit from "../levelEdit"
import SelectCategory from "../selectCategory"

const ButtonWrapper = styled.div`
    ${Button} {
        margin-top: 8px;
    }
`

interface TemplateLevelListProps {
    labelId: number
    categoryId: number
    editAccess: boolean
}

const TemplateLevelList = ({
    labelId,
    categoryId,
    editAccess,
}: TemplateLevelListProps) => {
    const template = useSelector((state: StoreType) => state.rrsTemplate.templateEdit)
    const templateLevelList = useSelector((state: StoreType) => state.rrsTemplate.levelList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [levelIds, setLevelIds] = useState<readonly number[]>([])
    const [levelList, setLevelList] = useState<RrsTemplateLevelList>({})

    useEffect(() => {
        if (!templateLevelList) return
        if (templateLevelList[labelId] && templateLevelList[labelId][categoryId]) {
            setLevelIds(templateLevelList[labelId][categoryId].levelIds)
            setLevelList(templateLevelList[labelId][categoryId].levelList)
        } else {
            setLevelIds([])
            setLevelList({})
        }
    }, [templateLevelList])

    const onDelete: DeleteRow = (level: RrsTemplateLevel, callback) => {
        DeleteRrsTemplateLevel(level.id).then((removedRows) => {
            const success = removedRows === 1
            callback(success, () => {
                const levelIdsCopy = levelIds.filter((id) => id !== level.id)
                const levelListCopy = { ...levelList }
                delete levelListCopy[level.id]
                dispatch(setRrsTemplateLevelListByCategory(labelId, categoryId, levelIdsCopy, levelListCopy))

                SetRrsTemplateRiskMapGenerated([template.id], false).then(() => { // set riskMapGenerated to "false"
                    dispatch(setRrsTemplateEdit({
                        ...template,
                        riskMapGenerated: false,
                    }))
                })
            })
        })
    }

    const columns = Columns(editAccess)
    const categoryListAccess = hasAccess(PRM_RRS_CATEGORY, LIST) // used only list from account level

    return (
        <Table
            columns={columns}
            dataList={levelList}
            dataIds={levelIds}
            rowSize="sm"
            showPagination={false}
            onDelete={onDelete}
            bottomContent={editAccess && (
                <ButtonWrapper>
                    <Button
                        row
                        variant="success"
                        onClick={() => dispatch(addModal({
                            key: "addLevel",
                            content: <TemplateLevelEdit levelId={0} labelId={labelId} categoryId={categoryId} />,
                        }))}
                    >
                        {lang.add}
                    </Button>
                    {
                        categoryListAccess && (
                            <Button
                                row
                                variant="success"
                                onClick={() => dispatch(addModal({
                                    key: "addFromLexicon",
                                    content: <SelectCategory labelId={labelId} categoryId={categoryId} />,
                                }))}
                            >
                                {lang.addFromLexicon}
                            </Button>
                        )
                    }
                </ButtonWrapper>
            )}
        />
    )
}
export default TemplateLevelList
